module.exports = __webpack_public_path__ + "static/img/sub02.fe69ff6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/sub02.png
// module id = tAid
// module chunks = 1